import { apiFetch } from './http';

// GET /api/user/captcha_id — request a fresh captcha id.
export async function getCaptchaId() {
  const response = await apiFetch('/api/user/captcha_id');
  if (!response.ok) throw new Error('Network response was not ok');
  return response.json();
}

// GET /api/user/captcha/{id} — captcha image (PNG) as a Blob.
export async function getCaptchaImage(captchaId) {
  const response = await apiFetch(`/api/user/captcha/${captchaId}`);
  if (!response.ok) throw new Error('Network response was not ok');
  return response.blob();
}
